import {IcnChevronDown, IcnChevronSelector, IcnClose} from "../../assets/icons";

import clsx from "clsx"
import {useField} from "formik"
import Select, {components, ControlProps, GroupBase, OptionProps, Props, SingleValueProps} from "react-select"

import {cFormGroupProps, cSelectOptionProps} from "../../utils";

import FormGroup from "./FormGroup";

interface FormInputSelectProps extends cFormGroupProps, Props {
  name: string;
  placeholder?: string;
  options: cSelectOptionProps[];
  chevronType?: "selector";
}

function FormInputSelect(
  {
    extraClassName,
    formGroupStyle,
    labelText,
    labelIsHidden,
    chevronType,
    name,
    placeholder,
    options,
    inputGroupText,
    inputGroupPlacement,
    formGroupExtraContent,
    helpText,
    hideError,
    ...rest
  }: FormInputSelectProps) {
  const [field, meta, helpers] = useField(name)

  const Control = ({ children, ...props }: ControlProps) => {
    return (
      <components.Control {...props}>
        {inputGroupText && (
          <span className="c-select__control-input-group-text">
            {inputGroupText}
          </span>
        )}
        {children}
      </components.Control>
    )
  }

  const SingleValue = ({children, ...props}: SingleValueProps<any>) => (
    <components.SingleValue {...props}>
      {props.data.icon && (
        <i className={clsx("c-select__single-value-icon", props.data.value)}>
          {props.data.icon}
        </i>
      )}
      <span className="c-select__single-value-label">{children}</span>
    </components.SingleValue>
  )

  const DropdownIndicator = ({ ...props }: any) => (
    <components.DropdownIndicator
      className={chevronType? chevronType : "default"}
      {...props}
    >
      {chevronType === "selector" ? (
        <IcnChevronSelector/>
      ):(
        <IcnChevronDown/>
      )}
    </components.DropdownIndicator>
  )

  const ClearIndicator = ({ ...props }: any) => (
    <components.ClearIndicator {...props}>
      <IcnClose/>
    </components.ClearIndicator>
  )

  const Option = ({children, ...props}: OptionProps<any, boolean, GroupBase<any>>) => (
    <components.Option {...props}>
      {props.data.icon && (
        <i className={clsx("c-select__option-icon", props.data.value)}>
          {props.data.icon}
        </i>
      )}
      {children}
    </components.Option>
  )

  const NoOptionsMessage = ({ ...props }: any) => (
    <components.NoOptionsMessage {...props}>
      No results found
    </components.NoOptionsMessage>
  )

  const handleChange = (option: any) => {
    if (Array.isArray(option)) {
      // For multi-select
      helpers.setValue(option.map((opt: any) => opt.value))
    } else {
      // For single-select
      helpers.setValue(option.value)
    }
  }

  return (
    <FormGroup
      extraClassName={clsx("c-form-group-select", extraClassName && extraClassName)}
      formGroupStyle={formGroupStyle}
      name={name}
      labelText={labelText}
      labelIsHidden={labelIsHidden}
      inputGroupText={inputGroupText}
      inputGroupPlacement={inputGroupPlacement}
      formGroupExtraContent={formGroupExtraContent}
      helpText={helpText}
      hideError={hideError}
      hasErrors={meta.touched && meta.error}
      errorText={meta.error}
    >

      <Select
        className={clsx("c-select")}
        classNamePrefix="c-select"
        id={`id_select_${name}`}
        inputId={`id_${name}`}
        name={field.name}
        placeholder={placeholder? placeholder : ""}
        aria-invalid={!!(meta.touched && meta.error)}
        options={options}
        value={options.find(option => option.value === field.value)}
        onChange={handleChange}
        components={{
          Control,
          SingleValue,
          Option,
          ClearIndicator,
          DropdownIndicator,
          NoOptionsMessage
        }}
        {...rest}
      />

    </FormGroup>
  )
}

export default FormInputSelect